import {gql, useMutation} from '@apollo/client';
import {PullAllFeeComponents} from '../schema-types/PullAllFeeComponents';

export const PULL_ALL_FEES = gql`
  mutation PullAllFeeComponents {
    pullAllFeeComponents {
      ok
    }
  }
`;

export const usePullAllFeeComponents = () => {
  const [pullAllFeeComponents, {data}] = useMutation<PullAllFeeComponents>(PULL_ALL_FEES);

  return {
    pullAllFeeComponents,
    data,
  };
};
